
import { useState } from 'react';
import { toast } from '@/hooks/use-toast';

export const useVoicePlayback = () => {
  const [isPlaying, setIsPlaying] = useState<string | null>(null);
  const [audioElement, setAudioElement] = useState<HTMLAudioElement | null>(null);

  const playMessage = async (messageId: string, audioUrl?: string) => {
    if (!audioUrl) {
      toast({
        title: "No audio available",
        description: "This message doesn't have an audio version.",
      });
      return;
    }

    // Stop current audio if playing
    if (audioElement) {
      audioElement.pause();
      if (isPlaying === messageId) {
        setIsPlaying(null);
        return;
      }
    }

    try {
      const audio = new Audio(audioUrl);
      audio.onended = () => {
        setIsPlaying(null);
        setAudioElement(null);
      };
      audio.onpause = () => {
        setIsPlaying(null);
      };
      audio.onplay = () => {
        setIsPlaying(messageId);
      };
      
      setAudioElement(audio);
      await audio.play();
    } catch (err) {
      console.error("Error playing audio:", err);
      toast({
        title: "Audio Error",
        description: "Could not play the audio message.",
        variant: "destructive"
      });
    }
  };

  return {
    isPlaying,
    playMessage
  };
};
